import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';

import Analytics from 'APP_ROOT/services/analytics';
import BuildSettings from '../../buildSettings';
import RavenUtil from '../../common/ravenUtil';
import MapboxMap from '../../mapbox/mapboxMapTripshare';
import Events from '../../common/events';
import MqttWebSocketService from '../../common/mqttWebSocketService';
import TripSharingSidebar from './tripSharingSidebar';

import { strings } from '../../../localization';

export default class TripSharingPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            trip: null,
            ravens: null,
            selectedRaven: null,
            destinationName: null,
            tripComplete: false,
            error: false,
            lookingForPreview: true
        }
    }

    componentDidMount() {
        Analytics.pageView();
        //get trip json
        this.getTripQuery();
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.ts_loading) } }));

        this.tabLastFocusedTime = Date.now();
    }

    componentWillUnmount() {

        if (this.mqttWSClient) this.mqttWSClient.disconnect();
    }

    getTripQuery() {

        this.tripQuery = 'query { trip(tripUuid:"' + this.props.match.params.tripUuid + '") { tripUuid ravenUuid password preview {ts imageData} currentDriver status route {ts lat lon} eta destination {lat lon} vehicle:carPersona { name } } }';
        axios({
            method: 'post',
            url: BuildSettings.tripSharingQueryUrl(),
            data: { "query": this.tripQuery },
        }).then(this.onTripQueryResponse).catch(function (response) {
            console.error('error', response);
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        });
    }

    //error 4006 if resource not found
    //https://sites.google.com/a/klashwerks.com/technical/design/error-codes-1/kloud-error-codes
    onTripQueryResponse = (response) => {

        // console.log('trip data:', response.data);
        try {
            let trip = response.data.trip;
            trip.route = RavenUtil.sortRoute(trip.route);
            var ravenObj = {
                vehicle: trip.vehicle,
                dashboard: {
                    route: trip.route,
                    events: [],
                    status: trip.status
                },
                lastLocation: trip.route.last(),
                ravenUuid: trip.tripUuid,
                preview: trip.preview.imageData,
                previewTs: moment(trip.preview.previewTs).valueOf(),
                vehicleState: {
                    heading: 0
                },
                mqttConnected: false,
                isDriving: (trip.status.toLowerCase() === 'driving')
            };
            ravenObj = RavenUtil.updateHeading(ravenObj);
            this.setState({
                trip: trip,
                ravens: [
                    ravenObj
                ],
                selectedRaven: ravenObj,
                lookingForPreview: false
            });
            //mqtt listener
            this.mqttWSClient = new MqttWebSocketService(trip.tripUuid, trip.password, this.onTripUpdate, this.onMQTTConnectionChanged);
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        } catch (e) {
            console.error(e);
            this.setState({ error: true });
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        }
    }

    onMQTTConnectionChanged = (connected) => {

        try {
            this.setState({
                mqttConnected: connected
            })
            //get preview
            this.onGetNewImage();
        } catch (e) {
            console.warn(e);
        }
    }

    onTripUpdate = (tripUpdate) => {

        try {
            //update trip data
            let trip = this.state.trip;
            if (tripUpdate.route && tripUpdate.route.length > 0) trip.route = trip.route.concat(tripUpdate.route);
            if (tripUpdate.currentDriver) trip.currentDriver = tripUpdate.currentDriver;
            if (tripUpdate.vehicle) trip.vehicle = tripUpdate.vehicle;
            if (tripUpdate.status) trip.status = tripUpdate.status;
            if (tripUpdate.preview) {
                trip.preview.imageData = tripUpdate.preview;
                trip.preview.ts = Date.now();
                if (this.state.lookingForPreview) {
                    this.setState({
                        lookingForPreview: false
                    })
                }
            }
            trip.heading = RavenUtil.updateHeading(null, trip.route).vehicleState.heading;

            this.state.ravens[0].dashboard.route = trip.route;
            this.state.ravens[0].dashboard.currentDriver = trip.currentDriver;
            this.state.ravens[0].dashboard.vehicle = trip.vehicle;
            this.state.ravens[0].dashboard.status = trip.status;
            this.state.ravens[0].preview = trip.preview.imageData;
            this.state.ravens[0].previewTs = moment(trip.preview.ts).valueOf();
            this.state.ravens[0].vehicleState = trip.vehicleState;
            if (!this.state.ravens[0].vehicleState) this.state.ravens[0].vehicleState = {};
            this.state.ravens[0].vehicleState.heading = trip.heading;
            this.state.ravens[0].isDriving = (trip.status.toLowerCase() === 'driving');

            this.setState({
                trip: trip,
                ravens: this.state.ravens,
                selectedRaven: this.state.ravens[0]
            })
        } catch (e) {
            console.error(e);
        }
    }

    onGetNewImage = (e) => {

        this.setState({
            lookingForPreview: true
        })
        var url = BuildSettings.tripSharingPreviewUrl(this.props.match.params.tripUuid)
        axios({
            method: 'get',
            url: url
        }).then(this.onPreviewQueryResponse).catch((response) => {
            console.error('error', response);
            this.setState({
                lookingForPreview: false
            })
        });
    }

    onPreviewQueryResponse = (response) => {

        console.log('preview query response:', response);
    }

    render() {

        document.querySelector('html').classList.add('dark-theme');

        if (this.state.selectedRaven !== null) {
            const features = {
                traffic: false,
            };
            return (
                <div className="dashboard-page trip-sharing-page">
                    <div className="trip-sharing-main-wrapper">
                        <div className="trip-map">
                            <MapboxMap
                                mapId="tripSharingMap"
                                ravens={this.state.ravens}
                                selectedRaven={this.state.selectedRaven}
                                features={features}
                                tripSharing={true} />
                        </div>
                        <div className="trip-feed">
                            <TripSharingSidebar
                                raven={this.state.selectedRaven}
                                onGetNewImage={this.onGetNewImage}
                                lookingForPreview={this.state.lookingForPreview}
                                mqttConnected={this.state.mqttConnected} />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div id="tripSharingErrorPage" className="container page-container">
                <div className="page-error">
                    <h2>{strings.formatString(strings.ts_expired_title)}</h2>
                    <hr />
                    <p>{strings.formatString(strings.ts_expired_m1)}</p>
                </div>
            </div>
        );
    }
}
